import posthog from 'posthog-js'

/** Analytics must never break the quiz. */
const capture = (event: string, properties: Record<string, unknown>) => {
  try {
    posthog.capture(event, properties)
  } catch {
    /* ignore */
  }
}

/**
 * quiz_submitted, with the same properties as the apps (QuizStore): story_id, level, is_correct.
 * `answer` is the POST quiz response, which carries selectedAnswer and rightAnswer.
 */
export const captureQuizSubmitted = (storyId: string, level: string | null | undefined, answer: any) => {
  if (!answer || answer.rightAnswer === undefined || answer.rightAnswer === null) return
  capture('quiz_submitted', {
    story_id: storyId,
    level: level || 'unknown',
    is_correct: String(answer.selectedAnswer) === String(answer.rightAnswer),
  })
}
